<div class="component-dialog-alert">
    <div class="cda-header">
      <span class="cda-header-text">{{ dataDialog.title }}</span>
    </div>
    <div class="cda-body">
      {{ dataDialog.message }}
    </div>
    <div class="cda-footer" (click)="onClickAccept()" *ngIf="showFooter">
      <span class="cda-footer-btn-text">{{ dataDialog.buttonText }}</span>
    </div>
  </div>
  